import { nonPageTracker } from '@src/adobe-launch/data-layer-provider';
import { TrackingEvent } from '@src/adobe-launch/types';
import { withBasePath } from '@src/common/path-convert';
import useWindowSize from '@src/utils/useWindowSize';
import { isiOSShare, isPC } from '@src/utils/util';
import { getYear } from 'date-fns';
import { useTranslation } from 'next-i18next';
import Head from 'next/head';
import { useEffect, useMemo } from 'react';
import cn from 'classnames';
import { debounce } from 'lodash';
import { ContentBlockFragment } from '@graphqlTypes/sitecore';

interface Props {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    contentBlock: ContentBlockFragment | any;
}

const DefaultPage = (props: Props) => {
    const { contentBlock } = props;
    // console.log('share-props------', contentBlock);
    const { width } = useWindowSize();
    const pc = width >= 1000;
    const smallPhont = width <= 375;
    const { t, i18n } = useTranslation('share');
    const isEn = i18n.language === 'en-US';

    const title = contentBlock?.pageTitle?.value || '';
    const id = contentBlock?.id || '';

    const locatSea =
        typeof window !== 'undefined' && window.location && window.location
            ? window.location.pathname
            : '';

    const currentPath = locatSea.split('/share/')[1] || '';

    console.log('currentPath----', currentPath);

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const GetPath: any = {
        en_US_ios: 'https://apps.apple.com/hk/app/id432462569?l=en',
        zh_HK_ios: 'https://apps.apple.com/hk/app/id432462569?l=zh-hk',
        en_US_andriod: 'https://m.hkjc.com/en/download-classic-3-in-1.html',
        zh_HK_andriod: 'https://m.hkjc.com/tc/download-classic-3-in-1.html',
    };

    const openShareUrl = debounce(
        () => {
            nonPageTracker(
                {
                    eventID: TrackingEvent.Open3in1,
                    title,
                    id,
                },
                undefined,
                true
            );
            if (isPC) {
                return;
            }
            window.open(`hkjcbet://discover/${currentPath}`, `_self`);
        },
        500,
        { leading: true, trailing: false }
    );

    const GoDownload = debounce(
        () => {
            nonPageTracker(
                {
                    eventID: TrackingEvent.Download3in1,
                    title,
                    id,
                },
                undefined,
                true
            );
            const b = i18n.language.split('-').join('_');
            if (isiOSShare) {
                window.location.href = GetPath[`${b}_ios`];
            } else {
                window.location.href = GetPath[`${b}_andriod`];
            }
        },
        500,
        { leading: true, trailing: false }
    );

    const { titleHtml, imgHtml, descriptionHtml } = useMemo(() => {
        return { titleHtml: '', imgHtml: '', descriptionHtml: '' };
    }, []);

    useEffect(() => {
        return () => {
            openShareUrl.cancel();
            GoDownload.cancel();
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <div>
            <Head>
                <title>{titleHtml}</title>
                <meta property='og:title' content={titleHtml} key='title' />
                <meta property='og:image' content={imgHtml} />
                <meta property='og:description' content={descriptionHtml} />
            </Head>
            <div className='w-[100vw] h-[100vh] bg-[#FAFAFA] overflow-auto'>
                <div className='bg-[#003063] border-solid border-b-4 border-[#FFCC28] px-[28px] py-[9px]'>
                    <img
                        className='w-[140px]'
                        alt=''
                        loading='lazy'
                        src={withBasePath(
                            isEn
                                ? '/images/sharePage/logo_eng.png'
                                : '/images/sharePage/logo_chi.png'
                        )}
                    />
                </div>
                {pc ? (
                    <div className='flex justify-center items-center flex-row pt-[30px]'>
                        <img
                            src={withBasePath('/images/sharePage/c_app.png')}
                            alt=''
                            loading='lazy'
                            className='w-[454px] mt-[19px] mb-[25px]'
                        />
                        <div className='pl-[120px]'>
                            <div className='flex items-center'>
                                <img
                                    className='w-[64px]'
                                    src={withBasePath('/images/sharePage/c_icon.png')}
                                    loading='lazy'
                                    alt=''
                                />
                                <div className='text-[24px] font-medium text-[#012E65] pl-[15px]'>
                                    {t('share:title')}
                                </div>
                            </div>

                            <div className='text-[15px] font-medium text-[#012E65] mt-[24px] mb-[12px] px-[12px]'>
                                {t('share:secondTitle')}
                            </div>

                            <div className='flex'>
                                <div className='w-[220px]'>
                                    <div
                                        className='w-[172px] h-[40px] leading-[40px]  text-[15px] font-medium text-center bg-[#FECC28] text-black rounded-[20px] cursor-pointer'
                                        onClick={openShareUrl}
                                    >
                                        {t('share:defBtnOpen')}
                                    </div>
                                    <div className='pt-[8px] pb-[16px] text-[12px]'>
                                        {t('share:notice')}
                                    </div>
                                </div>
                                <div
                                    className='w-[172px] h-[40px] leading-[40px] text-[15px] font-medium text-center bg-[#63779D] text-white rounded-[20px] cursor-pointer'
                                    onClick={GoDownload}
                                >
                                    {t('share:defDownLoad')}
                                </div>
                            </div>

                            <div className=' text-[12px] pt-[10px] pb-[20px]'>
                                {isEn ? (
                                    <>
                                        <strong>Play Responsibly</strong>
                                        <br />
                                        No person under 18 is allowed to bet or enter premises where
                                        bets are accepted.
                                        <br />
                                        Betting with illegal or overseas bookmakers is against the
                                        law and offenders may be liable to imprisonment.
                                        <br />
                                        Don&apos;t gamble your life away. Call Ping Wo Fund hotline
                                        1834 633 if you need help or counselling.
                                        <br />
                                        Copyright © 2000-{getYear(new Date())} The Hong Kong Jockey
                                        Club
                                    </>
                                ) : (
                                    <>
                                        <strong>博彩要有節制</strong>
                                        <br />
                                        未滿十八歲人士不得投注或進入可投注的地方。
                                        <br />
                                        向非法或海外莊家下注，即屬違法，且可被判監禁。
                                        <br />
                                        切勿沉迷賭博，如需尋求輔導協助，可致電平和基金熱線1834 633。
                                        <br />
                                        版權所有 不得轉載 © 2000-{getYear(new Date())} 香港賽馬會
                                    </>
                                )}
                            </div>
                        </div>
                    </div>
                ) : (
                    <div className='flex justify-center items-center flex-col'>
                        <img
                            className='w-[60px] mt-[33px] mb-[10px]'
                            src={withBasePath('/images/sharePage/c_icon.png')}
                            alt=''
                            loading='lazy'
                        />
                        <div className='text-[24px] font-medium text-[#012E65]'>
                            {t('share:title')}
                        </div>
                        <div
                            className={cn(
                                smallPhont && 'px-7',
                                'text-[15px] font-medium text-[#012E65] text-center'
                            )}
                        >
                            {t('share:secondTitle')}
                        </div>
                        <img
                            src={withBasePath('/images/sharePage/c_app.png')}
                            alt=''
                            loading='lazy'
                            className='w-[275px] mt-[19px] mb-[25px]'
                        />
                        <div
                            className='w-[172px] h-[40px] leading-[40px]  text-[15px] font-medium text-center bg-[#FECC28] text-black rounded-[20px] cursor-pointer'
                            onClick={openShareUrl}
                        >
                            {t('share:defBtnOpen')}
                        </div>
                        <div className='pt-[8px] pb-[16px] text-[12px]'>{t('share:notice')}</div>

                        <div
                            className='w-[172px] h-[40px] leading-[40px] text-[15px] font-medium text-center bg-[#63779D] text-white rounded-[20px] cursor-pointer'
                            onClick={GoDownload}
                        >
                            {t('share:defDownLoad')}
                        </div>

                        <div className='px-[12px] text-[12px] pt-[10px] pb-[20px]'>
                            {isEn ? (
                                <>
                                    <strong>Play Responsibly</strong>
                                    <br />
                                    No person under 18 is allowed to bet or enter premises where
                                    bets are accepted.
                                    <br />
                                    Betting with illegal or overseas bookmakers is against the law
                                    and offenders may be liable to imprisonment.
                                    <br />
                                    Don&apos;t gamble your life away. Call Ping Wo Fund hotline 1834
                                    633 if you need help or counselling.
                                    <br />
                                    Copyright © 2000-{getYear(new Date())} The Hong Kong Jockey Club
                                </>
                            ) : (
                                <>
                                    <strong>博彩要有節制</strong>
                                    <br />
                                    未滿十八歲人士不得投注或進入可投注的地方。
                                    <br />
                                    向非法或海外莊家下注，即屬違法，且可被判監禁。
                                    <br />
                                    切勿沉迷賭博，如需尋求輔導協助，可致電平和基金熱線1834 633。
                                    <br />
                                    版權所有 不得轉載 © 2000-{getYear(new Date())} 香港賽馬會
                                </>
                            )}
                        </div>
                    </div>
                )}
            </div>
        </div>
    );
};

export default DefaultPage;
